import type { CombinedError } from "urql";
import { isClientErrorExtensions } from "@linear/common/errors/ClientErrorExtension";

/**
 * Extracts a message that can be shown to the user from a failed urql operation result.
 *
 * Prefers the API's `userPresentableMessage` error extension, then falls back to the raw GraphQL error message, then
 * to the provided fallback.
 *
 * @param error The combined error returned by urql, if any.
 * @param fallback The message to use when the error carries no displayable information.
 * @returns The message to display to the user.
 */
export function userFacingErrorMessage(error: CombinedError | undefined, fallback: string): string {
  const graphQLError = error?.graphQLErrors[0];
  if (!graphQLError) {
    return fallback;
  }

  if (isClientErrorExtensions(graphQLError.extensions) && graphQLError.extensions.userPresentableMessage) {
    return graphQLError.extensions.userPresentableMessage;
  }

  return graphQLError.message || fallback;
}
